import styled, { css, keyframes } from 'styled-components';
import { media } from '../../common/Layout';

const MainLayout = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1070px;
  width: 100%;

  padding-left: 16px;
  padding-right: 16px;

  ${media.desktop`    
    padding-left: 0px;
    padding-right: 0px;
  `};
`;

export default MainLayout;

export const ItemContainer = styled.div`
  width: 100%;
  &:last-child {
    margin-bottom: 0px;
  }

  /* Mobile Device */
  margin-bottom: 18px;

  ${media.desktop`
    margin-bottom: 26px;
  `};
`;

export const ItemTitleBox = styled.a`
  font-family: 'NotoKrM';
  width: fit-content;
  font-weight: 500;
  color: #1a0dab;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  em {
    font-family: 'NotoKrB';
    font-style: normal;
  }

  /* Mobile Device */
  -webkit-line-clamp: 2;
  margin-bottom: 3px;
  font-size: 15px;

  ${media.desktop`
    -webkit-line-clamp: 1;
    height: 29px;
    margin-bottom: 6px;
    font-size: 20px;
  `};
`;

export const ItemDescBox = styled.div`
  font-family: 'NotoKrL';
  width: 100%;
  font-weight: 300;
  color: #222222;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  em {
    font-family: 'NotoKrM';
    font-style: normal;
  }

  /* Mobile Device */
  -webkit-line-clamp: 3;
  margin-bottom: 3px;
  font-size: 13px;

  ${media.desktop`
    -webkit-line-clamp: 2;
    max-height: 43px;
    margin-bottom: 6px;
    font-size: 14px;
  `};
`;

export const ItemSourceBox = styled.div`
  width: 100%;
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ItemAttachTitleBox = styled.div`
  display: flex;
  width: 100%;

  /* Mobile Device */
  /* height: 44px; */
  margin-bottom: 3px;
  font-size: 15px;

  ${media.desktop`
    height: 29px;
    margin-bottom: 6px;
    font-size: 20px;
  `};
`;

export const ItemTitle = styled.a`
  font-family: 'NotoKrM';
  color: #1a0dab;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;

  /* Mobile Device */
  -webkit-line-clamp: 1;

  ${media.desktop`
    -webkit-line-clamp: 1;
  `};
`;

export const IconDownloadImg = styled.img`
  /* Mobile Device */
  height: 20px;

  ${media.desktop`
    height: 30px;
  `};
`;

interface sytleType {
  isActive?: boolean;
}

export const PaginationBox = styled.div`
  display: flex;
  justify-content: center;

  /* Mobile Device */
  margin-top: 26px;

  ${media.desktop`
    margin-top: 50px;
  `};
`;

export const PaginationButton = styled.button`
  font-family: 'NotoKrL';
  border: none;
  background-color: transparent;
  font-size: 16px;

  /* Mobile Device */
  min-width: 35px;
  height: 35px;

  ${media.desktop`
    min-width: 50px;
    height: 50px;
  `};

  :focus {
    outline: none;
  }
  ${(props: sytleType) => {
    if (props.isActive) {
      return css`
        font-family: 'NotoKrM';
        border-bottom: 3px solid #1f88e5;
      `;
    }
    return css``;
  }}
`;

export const ListContainter = styled.div`
  width: 100%;
  padding-top: 24px;
`;

export const MoreViewBox = styled.div`
  display: flex;
  align-items: center;

  /* Mobile Device */
  height: 19px;
  margin-bottom: 12px;

  ${media.desktop`
    height: 24px;
    margin-bottom: 18px;
  `};
`;

export const MoreViewArrow = styled.img`
  margin-right: 5.5px;
  margin-bottom: 2px;
  /* Mobile Device */
  height: 9px;

  ${media.desktop`
    height: 11px;
  `};
`;
export const MoreViewTitle = styled.div`
  font-family: 'NotoKrM';
  display: flex;
  align-items: center;
  color: #555555;
  cursor: pointer;

  /* Mobile Device */
  font-size: 13px;

  ${media.desktop`
    height: 20px;
    font-size: 16px;
  `};
`;

export const MoreViewBoxResult = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  /* Mobile Device */
  justify-content: center;
  height: 46px;
  border-radius: 23px;
  border: solid 1px #cccccc;
  margin-top: 10px;

  ${media.desktop`
    height: 20px;
    justify-content: flex-end;
    border-radius: 0px;
    border: none;
    margin-top: 0px;
  `};
`;

export const MoreViewInnerBoxResult = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 100%;
  /* Mobile Device */
  width: 100%;

  ${media.desktop`
    width: fit-content;
  `};
`;

export const MoreViewArrowResult = styled.img`
  height: 16px;
  margin-right: 2px;
  margin-bottom: 2px;
`;
export const MoreViewTitleResult = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
  font-size: 14px;
  color: #1a0dab;
`;

export const NoDataTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-family: 'NotoKrL';
  color: #222222;
  em {
    font-family: 'NotoKrM';
    font-style: normal;
  }

  /* Mobile Device */
  font-size: 15px;

  ${media.desktop`  
    font-size: 20px;
  `};
`;
